<template>
  <aside class="main-sidebar navbar-white main-sidebar">      
    <a href="javascript:;" class="brand-link logo-switch">
      <img src="@/assets/logo.png"  class="brand-image-xs logo-xl my-2 mx-5">
    </a>
          
      <!-- Sidebar -->
      <div class="sidebar">
        <div class="pt-5">
          <ul class="nav nav-pills nav-sidebar nav-child-indent flex-column menu-list" data-widget="treeview" role="menu" data-accordion="false">
            <li 
              v-for="m in getMenu" :key="m.menu"
              class="nav-item" 
              @click="hideBar"
            >
              <router-link
                :to="{name: m.weblink}"
                class="nav-link text-dark"
                :style="{background: $route.name == m.weblink ? 'rgba(0,0,0,.1)': ''}"
              >
                <img :src="getIcono(m.menu)" class="iconos">
                <p>{{ m.nmenu }}</p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
  </aside>
</template>
<script>
  export default {
    name: 'AppMenuOpcion',
    props: {
      menu: {
        type: Array,
        required: true
      }
    },
    methods: {
      getIcono(menu) {
        const tmp = {
          1491: 'home.png',
          1292: 'grid.png',
          1293: 'form.png',
          1286: 'folder.png',
          1284: 'users.png',
          1295: 'paper.png',
          1320: 'sales.png',
          1453: 'paper.png'
        };

        let icono = tmp[parseInt(menu)] === undefined ? 'paper.png' : tmp[parseInt(menu)];
        return require('../assets/img/iconos/'+icono);
      },
      hideBar () {
        let elements = document.getElementsByClassName('sidebar-mini')

        if (elements.length > 0) {
          let bar = elements[0]

          if (bar.classList.contains('sidebar-open')) {
            bar.classList.remove('sidebar-open')
            bar.classList.add('sidebar-closed')
            bar.classList.add('sidebar-collapse')
          }
        }
      }
    },
    computed: {
      getMenu() {
        let opciones = []

        if (this.menu) {
          this.menu.forEach(m => {
            m.opciones.forEach(i => opciones.push(i))
          })
        }

        if (opciones.length) {
          opciones = opciones.sort((a, b) => a.orden - b.orden)
        }

        return opciones
      }
    }
  }
</script>